export const NAMESPACES = {
  NO: 'No',
  YES: 'Yes',
  LOGOUT_MESSAGE: 'Are you sure you want to Logout?',
  SESSION_INACTIVITY_TITLE: 'Session timeout',
  SESSION_INACTIVITY_BODY:
    "You've been inactive for 14 minutes. For security reasons, your session will expire in 1 minute.\n\nSelect Continue Session to remain signed in.",
  SESSION_INACTIVITY_CONTINUE: 'Continue session',
  MANDATORY_RELOGIN_SOFT_TITLE: 'Session ending soon',
  MANDATORY_RELOGIN_SOFT_BODY:
    'Your maximum session time will end soon. You can sign out now, close this reminder, or extend your session by 10 minutes (up to two extensions). After that, you must sign in again.',
  MANDATORY_RELOGIN_ACKNOWLEDGE: 'Acknowledge',
  MANDATORY_RELOGIN_HARD_TITLE: 'Session limit reached',
  MANDATORY_RELOGIN_HARD_BODY:
    'Your maximum allowed session time has ended. Sign in again to continue.',
  MANDATORY_RELOGIN_LOGOUT_BUTTON: 'Sign out',
  MANDATORY_RELOGIN_EXTEND_SESSION: 'Extend 10 minutes',
  MANDATORY_RELOGIN_LOGOUT_NOW: 'Sign out now',
  MANDATORY_RELOGIN_CLOSE_WARNING: 'Close',
  ENTITY_DATA_MESSAGE: 'Manage data for Specific Entities',
  CANCEL_BUTTON: 'Cancel',
  DONE_BUTTON: 'Done',
  UPDATE_BUTTON: 'Update',
  SAVE_BUTTON: 'Save',
  DASHBOARD: 'Dashboard',
  ENTITY: 'No Entity Present',
  ENTITIES: 'Entities -',
  TAG: 'No data present. Click on "Add Entity" button to add data.',
  DASHBOARD_TAGLINE: 'This is work in progress.. !!!!',
  BOOKMARKED_ENTITIES: 'Bookmarked Entities',
  BOOKMARK_ENTITIES: 'Bookmark Entities',
}

export const PAGE_LAYOUT = {
  HOME_PAGE: 'Home Page',
  MY_WORK_BENCH: 'My Work Bench',
  ENTITIES: 'Entities',
  SEARCH: 'Search',
  LOGS: 'Logs',
  INTEGRATION: 'Integration',
  CORRESPONDENCE: 'Correspondence',
  INTEGRATION_LOGS: 'Integration Log',
  CASES: 'Cases',
  MY_TEAM: 'My Team',
  MY_TASK: 'My Task',
  ENROLLMENTS: 'Enrollments',
  PATIENT_ADHERENCE: 'Patient Adherence',
  CALL_INTERACTION: 'Interaction',
  QUEUE: 'Queue',
  BENEFIT_VERIFICATION: 'Benefit Verification',
  QUEUES: 'Queues',
  MANAGE_QUEUE: 'Manage Queues',
  APPLICATION_PREFERENCES: 'Application Preferences',
  INTAKE_NEW: 'Intake New',
  PERMISSION_ASSIGNMENT: 'Permission Assignment',
  WORKBASKET: 'Workbasket',
  OPERATIONAL_REPORTS: 'Operational Reports',
}

export const TypeAction = {
  CREATE: 'Create',
  Edit: 'Edit',
  View: 'View',
}

export const elementDataQaIdNames = {
  SINGLE_LINE: 'single-line-element-field',
  NUMBER: 'number-element-field',
  MULTI_LINE: 'multi-line-element-field',
  DROPDOWN: 'dropdown-element-field',
  CHECKBOX: 'checkbox',
  DATE_TIME: 'date-time-element-field',
  TIME: 'time-element-field',
  DATE: 'date-element-field',
  RADIO_GROUP: 'radio-group-element-field',
  SSN: 'ssn-element-field',
  PHONE_NUMBER: 'phone-number-element-field',
  UPLOAD: 'upload-element-field',
  SINGLE_LOOKUP: 'single-lookup-element-field',
  HEADING: 'heading-element-field',
  PARAGRAPH: 'paragraph-element-field',
  DEFAULT_FIELD: 'default-element-field',
}
